import { Tag } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { SourcingEventStatus } from "../../../autogen/bff-api";

interface Props {
  status: SourcingEventStatus;
  size?: "sm" | "md" | "lg";
}

// Labels are looked up dynamically by status, so langen can't see them statically:
// t("Draft") t("Awaiting Doffin") t("Live") t("Publication failed") t("Under evaluation") t("Award decision") t("Awarded") t("Cancelled") t("Closed") t("Completed")
const meta: Record<SourcingEventStatus, { color: string; labelKey: string }> = {
  [SourcingEventStatus.Draft]: { color: "orange", labelKey: "Draft" },
  [SourcingEventStatus.PublicationPending]: { color: "blue", labelKey: "Awaiting Doffin" },
  [SourcingEventStatus.Published]: { color: "green", labelKey: "Live" },
  [SourcingEventStatus.PublicationFailed]: { color: "red", labelKey: "Publication failed" },
  [SourcingEventStatus.Evaluation]: { color: "blue", labelKey: "Under evaluation" },
  [SourcingEventStatus.AwardDecision]: { color: "purple", labelKey: "Award decision" },
  [SourcingEventStatus.Awarded]: { color: "purple", labelKey: "Awarded" },
  [SourcingEventStatus.Cancelled]: { color: "red", labelKey: "Cancelled" },
  [SourcingEventStatus.Closed]: { color: "gray", labelKey: "Closed" },
  [SourcingEventStatus.Completed]: { color: "gray", labelKey: "Completed" },
};

export const SourcingEventV2StatusTag = ({ status, size = "md" }: Props) => {
  const { t } = useTranslation();
  const { color, labelKey } = meta[status] ?? { color: "gray", labelKey: status as string };
  return (
    <Tag colorScheme={color} size={size} borderRadius="full">
      {t(labelKey)}
    </Tag>
  );
};
